
/**
 * 
 * @param {Array} inputs
 * @returns {Bool} True if the string is not empty
 */
const areStringsPopulated = (inputs) => {
    return inputs.every(input => {
        if(input === undefined || input === null || typeof input !== 'string'){
            return false;
        }else if(input.trim().length < 1){
            return false;
        }else{
            return true;
        }
    });
}

/**
 * 
 * @param {Array} email
 * @returns {Bool} True if email is valid
 */
const validateEmail = (email) => {
    const regex = /^\S+@\S+\.\S+$/;
    return regex.test(email.trim());
}


/**
 * 
 * @param {Object} event
 * @returns {Bool} True if the recurrence options pass validation
 */
const validateRecurrence = (event) => {
    if(!event.recurringInterval || !event.recurringFrequency){
        return false
    }

    const daysOfWeekSet = (event.recurrenceDaysOfWeek && event.recurrenceDaysOfWeek?.length > 0);
    const daysOfMonthSet = (event.recurrenceDaysOfMonth && event.recurrenceDaysOfMonth?.length > 0);
    const weeksOfMonthSet = (event.recurrenceWeeksOfMonth && event.recurrenceWeeksOfMonth?.length > 0);
    const monthsSet = (event.recurrenceMonths && event.recurrenceMonths?.length > 0);

    switch(event.recurringFrequency){
        case "Days":
            return true;
        case "Weeks":
            return daysOfWeekSet;
        case "Months":
            return daysOfMonthSet || (weeksOfMonthSet && daysOfWeekSet)
        case "Years":
            return monthsSet && (daysOfMonthSet || (weeksOfMonthSet && daysOfWeekSet))
    }
}


/**
 * Validates a US phone number. Accepts common formats (digits, spaces, dashes,
 * parentheses, optional leading +1). Returns true when 10 digits are present.
 */
const validatePhoneUS = (phone) => {
    if(!phone || typeof phone !== 'string') return false;
    const digits = phone.replace(/\D/g, '');
    // Allow 11 digits with leading 1, otherwise require 10.
    if(digits.length === 11 && digits.startsWith('1')) return true;
    return digits.length === 10;
}

/**
 * Normalizes a US phone number to a 10-digit string (no country code).
 * Returns null when the input is not a valid US phone.
 */
const normalizePhoneUS = (phone) => {
    if(!phone || typeof phone !== 'string') return null;
    let digits = phone.replace(/\D/g, '');
    if(digits.length === 11 && digits.startsWith('1')) digits = digits.slice(1);
    if(digits.length !== 10) return null;
    return digits;
}

/**
 * Validates a US ZIP code (5 digits, or 5+4 ZIP+4).
 */
const validateZip = (zip) => {
    if(!zip || typeof zip !== 'string') return false;
    return /^\d{5}(-\d{4})?$/.test(zip.trim());
}

const US_STATES = [
    'AL','AK','AZ','AR','CA','CO','CT','DE','FL','GA','HI','ID','IL','IN','IA',
    'KS','KY','LA','ME','MD','MA','MI','MN','MS','MO','MT','NE','NV','NH','NJ',
    'NM','NY','NC','ND','OH','OK','OR','PA','RI','SC','SD','TN','TX','UT','VT',
    'VA','WA','WV','WI','WY','DC',
];

/**
 * Validates a 2-letter US state abbreviation (case-insensitive).
 */
const validateState = (state) => {
    if(!state || typeof state !== 'string') return false;
    return US_STATES.includes(state.trim().toUpperCase());
}

/**
 * Returns the list of 2-letter US state abbreviations.
 */
const getUSStates = () => [...US_STATES];

/**
 * Validates an address object ({street1, street2, city, state, zip}).
 * street2 is optional. Uses US state + zip validation.
 */
const validateAddress = (address) => {
    if(!address || typeof address !== 'object') return false;
    const { street1, city, state, zip } = address;
    if(!street1 || typeof street1 !== 'string' || !street1.trim()) return false;
    if(!city || typeof city !== 'string' || !city.trim()) return false;
    if(!validateState(state)) return false;
    if(!validateZip(zip)) return false;
    return true;
}


export {
    areStringsPopulated,
    validateEmail,
    validateRecurrence,
    validatePhoneUS,
    normalizePhoneUS,
    validateZip,
    validateState,
    validateAddress,
    getUSStates,
}
